<template>
  <Skeleton>
    <template v-for="(_, slotName) in $slots" #[slotName]="slotProps">
      <slot :name="slotName" v-bind="slotProps ?? {}" />
    </template>
  </Skeleton>
</template>

<script setup lang="ts">
import type { SkeletonEmits, SkeletonProps } from "primevue";

import { Skeleton } from "primevue";

import "./pSkeleton.css";

defineProps</* @vue-ignore */ SkeletonProps>();
defineEmits</* @vue-ignore */ SkeletonEmits>();
</script>
